// Single source of truth for the PWA install prompt. Chrome fires
// `beforeinstallprompt` ONCE and the event can only be .prompt()'d once —
// multiple components capturing it independently causes silent failures.
let deferred = null;
const subs = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    subs.forEach((f) => f(true));
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    subs.forEach((f) => f(false));
    claimInstallReward();
  });
}

// One-time +25 POG BUCKS install reward for logged-in drivers. Safe to call
// repeatedly — guarded client-side by localStorage and server-side by a driver flag.
export const claimInstallReward = async () => {
  try {
    if (localStorage.getItem("airpog_install_reward_claimed")) return;
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/consumer/install-reward`, {
      method: "POST", credentials: "include",
    });
    if (res.status === 401) return; // guest — they can claim after logging in (standalone launch re-checks)
    const data = await res.json();
    localStorage.setItem("airpog_install_reward_claimed", "1");
    if (data.ok) {
      window.dispatchEvent(new CustomEvent("airpog:install-reward", { detail: data }));
    }
  } catch { /* ignore */ }
};

export const canInstall = () => !!deferred;

// Returns "accepted" | "dismissed" | "unavailable"
export const requestInstall = async () => {
  if (!deferred) return "unavailable";
  const evt = deferred;
  deferred = null;
  subs.forEach((f) => f(false));
  try {
    evt.prompt();
    const choice = await evt.userChoice;
    return choice?.outcome === "accepted" ? "accepted" : "dismissed";
  } catch {
    return "unavailable";
  }
};

export const onInstallableChange = (f) => {
  subs.add(f);
  return () => subs.delete(f);
};
